import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/dist/query/react';
import config from '../../config';
import i18n from '../../locales/i18n';
import { Assignment, AssignmentsResult, ServiceApiDocResult, ServiceApiResult } from './types';

export const serviceApi = createApi({
  reducerPath: 'service',
  baseQuery: fetchBaseQuery({
    baseUrl: config.serviceBackend,
  }),
  endpoints: builder => ({
    getServices: builder.query<ServiceApiResult, undefined>({
      query: () => '/services',
    }),
    getServiceDocumentation: builder.query<ServiceApiDocResult, string>({
      query: (service) => '/services/' + service + '/' + i18n.language + '/documentation',
      keepUnusedDataFor: 5,
    }),
    getAssignments: builder.query<AssignmentsResult, undefined>({
      query: () => '/assignments',
    }),
    getAssignment: builder.query<Assignment, string>({
      query: (title) => '/assignments/' + title
    })
  }),
});

export const { useGetServicesQuery, useGetServiceDocumentationQuery, useGetAssignmentsQuery, useGetAssignmentQuery } = serviceApi;
